export default {
    productDetails(state) {
        return state.productDetail;
    },
    getCartInfo(state) {
        return state.cartInfo;
    },
    getCartItems(state) {
        return state.cartInfo.items;
    }
};
